export const bonuses = [
  {
    number: 1,
    title: '30 Calm Response SOS Cards™',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/r9VV6w639uBaX8Qa7wthdC/BONUS_1_CALM-EN.png',
    body: 'I created 30 quick-reference cards for common situations. You can print them or keep them on your phone.',
    items: [] as string[],
    flow: ['What you may notice', 'What to check', 'Next step', 'What to avoid'],
  },
  {
    number: 2,
    title: 'The 21-Day Calmer Home Planner™',
    value: '$27',
    image: 'https://cdn.magicpatterns.com/uploads/sJgPmaazdWHLL7AonWpgbp/BONUS_2_CALM-EN.png',
    body: "I don't want you downloading the system and then forgetting about it. Each day gives you one small action, one observation and one opportunity to make your routine more predictable. Small steps. Real progress.",
    items: [] as string[],
    flow: [] as string[],
  },
  {
    number: 3,
    title: 'The Trigger & Pattern Map™',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/eyJMtXXxFYgDND81gY8vJm/BONUS_3_CALM-EN.png',
    body: 'One of my favorite tools, because it helps you stop relying entirely on memory. Over time, you can begin to see patterns that are specific to your family.',
    items: [
      'What happened before',
      'Where it happened',
      'What was around your child',
      'Early signs',
      'What you tried',
      'What happened afterward',
    ],
    flow: [] as string[],
  },
  {
    number: 4,
    title: 'Visual Routines Toolkit™',
    value: '$29',
    image: 'https://cdn.magicpatterns.com/uploads/piFpuWVcPyCKXf9SzZBsTZ/BONUS_4_CALM-EN.png',
    body: 'Ready-to-customize visual routines you can print and adapt to your child’s routine.',
    items: ['Mornings', 'Getting ready for school', 'Coming home', 'Meals', 'Bath time', 'Bedtime', 'Transitions', 'Unexpected changes'],
    flow: [] as string[],
  },
  {
    number: 5,
    title: 'The “Do This / Avoid That” Guide™',
    value: '$17',
    image: 'https://cdn.magicpatterns.com/uploads/jNju4LcV9s5Wjs5boHYbF9/BONUS_5_CALM-EN.png',
    body: "When your child is overwhelmed, it's easy for your own stress to take over. This quick-reference guide helps you remember what to focus on — and what responses may add unnecessary pressure.",
    items: [] as string[],
    flow: [] as string[],
  },
];
